
import React from 'react';
import styled from 'styled-components';
import { Divider as AntdDivider } from 'antd';

export type DividerSize = 'small' | 'middle' | 'large';

export interface DividerProps {
    size?: DividerSize;
    children?: React.ReactNode;
    type?: 'horizontal' | 'vertical';
    dashed?: boolean;
    orientation?: 'left' | 'right' | 'center';
    plain?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

// Map size to spacing (similar to AntD v5 defaults)
const sizeToMargin = {
    small: '8px 0',
    middle: '16px 0',
    large: '24px 0',
};

// Styled wrapper for AntD v4 Divider
const StyledDivider = styled(AntdDivider) <{ size?: DividerSize }>`
  margin: ${({ size = 'middle' }) => sizeToMargin[size]};
`;

export const Divider: React.FC<DividerProps> = ({ size = 'middle', ...rest }) => {
    return <StyledDivider size={size} {...rest} />;
};

